import { makeStyles } from "@material-ui/core";

export const usePinnedListsItemStyles = makeStyles(() => ({
    pinnedListWrapper: {
        display: "inline-block",
        width: 99,
        padding: "8px 15px 15px 15px",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "rgba(0, 0, 0, 0.03)"
        }
    },
    listAvatar: {
        width: "68px !important",
        height: "68px !important",
        borderRadius: 12,
        marginRight: 15
    },
    pinnedListName: {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textAlign: "center"
    }
}));
